import { ConcreteEncodable } from "./ConcreteEncodable";

import { SessionDisconnectRequestImplEncoder } from "../../encoder/SessionDisconnectRequestImplEncoder";

import * as CubiqTS from "../../index";
import { SessionDisconnectRequest } from "../SessionDisconnectRequest";

export class SessionDisconnectRequestImpl
  extends ConcreteEncodable
  implements SessionDisconnectRequest
{
  public static enType: string = "com.bcdfx.session.SessionDisconnectRequestImpl";

  /*FID=1*/
  public userCode: string;
  /*FID=2*/
  public sessionId: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SessionDisconnectRequestImplEncoder.Instance;
    this.setEncodableType(SessionDisconnectRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "SessionDisconnectRequestImpl[" +
      "userCode=" +
      this.userCode +
      "sessionId=" +
      this.sessionId +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
